import React from 'react';
import styled from 'styled-components';
import { getFontWeight } from '../../helpers/utils';

const ALIGNMENT_MAP = {
  LEFT: 'left',
  CENTRE: 'center',
  CENTER: 'center',
  RIGHT: 'right',
  JUSTIFY: 'justify',
};

const TextDisplayElement = ({
  name,
  component_text,
  content,
  label,
  alignment,
  font,
  attributes,
  component_type,
}) => {
  const textAlign = ALIGNMENT_MAP[(alignment || '').toUpperCase()] || 'left';
  const isHeader = component_type === 'HEADER';

  const fontStyle = {
    color: font?.color || attributes?.font?.color,
    fontFamily: font?.name || attributes?.font?.name,
  };

  // Priority: component_text (API field) > content > label
  const rawBody = component_text || content || label || null;

  // Plain text: convert newlines to <br>. HTML content: pass through as-is.
  const isHtml = rawBody && /<[a-z][\s\S]*>/i.test(rawBody);
  const bodyHtml = rawBody
    ? isHtml
      ? rawBody
      : rawBody.replace(/\n/g, '<br />')
    : null;

  return (
    // Set text-align on the wrapper so all children inherit it
    <TextDisplayWrapper style={{ textAlign }}>
      {name && (
        isHeader ? (
          <h2 className="display-heading" style={fontStyle}>{name}</h2>
        ) : (
          <p className="display-name" style={fontStyle}>{name}</p>
        )
      )}
      {bodyHtml && (
        <p
          className="display-body"
          style={{
            ...fontStyle,
            fontSize: font?.size || attributes?.font?.size,
            fontWeight: getFontWeight(font?.style || attributes?.font?.style),
          }}
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      )}
    </TextDisplayWrapper>
  );
};

const TextDisplayWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;

  .display-heading {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.3;
    color: #2a3348;
    margin: 0 0 6px;
  }

  .display-name {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: #2a3348;
    margin: 0 0 6px;
  }

  .display-body {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.6;
    color: #4a5568;
    margin: 0;

    p { margin: 0 0 8px; }
    p:last-child { margin-bottom: 0; }
  }
`;

export default TextDisplayElement;
